import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88f3bf4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Contact Details", -1))
const _hoisted_3 = { class: "main-details" }
const _hoisted_4 = { class: "tab-page" }
const _hoisted_5 = { class: "main-details" }
const _hoisted_6 = { class: "tab-page" }
const _hoisted_7 = { class: "tab-page" }
const _hoisted_8 = { class: "tab-page" }

import modalBase from "@/components/ui/modals/modal-base.vue";
import { computed, watch, ref, inject } from "vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import lookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { FieldSize } from "@/enums/system/FieldSize";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import { DxToolbarItem } from "devextreme-vue/popup";
import EditAddress from "@/components/ui/address/edit-address.vue";
import { EditAddressValidation } from "@/types/validation/EditAddressValidation";
import { Address } from "@/types/generic/Address";
import { CountryCode } from "bright-logic-core/src/CountryCode";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { getErrorMessage } from "bright-logic-core/src/errors";
import displayErrorMessage from "@/utils/ErrorHandling";
import { Contacts } from "acquaint-api/models/Contacts";
import { NewContactModel } from "@/types/contacts/NewContactModel";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import QuestionModal from "@/components/ui/modals/question-modal.vue";
import MarketingPreferenceToggles from "@/components/contacts/record/marketing-preference-toggles.vue";
import findQuestionText from "@/utils/system-text/FindQuestionText";
import BedroomsSelect from "@/components/ui/dropdowns/bedrooms-select.vue";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import { Id } from "@/types/generic/Id";
import { ContactModalPages } from "@/enums/contacts/ContactModalPages";
import { PropertyUsages } from "@/enums/properties/PropertyUsages";
import { PropertyCategories } from "@/enums/properties/PropertyCategories";
import NewContactTypeLookup from "@/components/ui/lookup/new-contact-type-lookup.vue";
import { SystemContactTypes } from "@/enums/contacts/SystemContactTypes";
import { useContactTypeConfigurationStore } from "@/stores/ContactTypeConfigurationStore";
import { ContactType } from "@/types/ContactType";
import { DuplicateContact } from "@/types/contacts/DuplicateContact";
import DuplicateContactModal from "@/components/contacts/record/duplicate-contact-modal.vue";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import moment from "moment";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { ContactType as ContactTypeId } from "@/enums/contacts/ContactType";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import { EmailTemplates } from "@/enums/contacts/EmailTemplates";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { DefaultContactType } from "acquaint-api/constants/DefaultContactType";
import { useContactHelper } from "@/utils/contacts/useContactHelper";

const originalMaxPrice = 99999999;
const originalMinBedrooms = 0;

export default /*#__PURE__*/_defineComponent({
  __name: 'contact-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },

  /**
   * Determines if input fields should be locked (disabled).
   * @type {boolean}
   * @default false
   */
  lockInputs: {
    type: Boolean,
    default: false,
  },

  /**
   * Indicates whether the user is the owner.
   * @type {boolean}
   * @default false
   */
  isOwner: {
    type: Boolean,
    default: false,
  },

  /**
   * Controls the visibility of the "Add Property" prompt.
   * @type {boolean}
   * @default true
   */
  showAddPropertyPrompt: {
    type: Boolean,
    default: true,
  },

  /**
   * Indicates whether the user is an applicant.
   * @type {boolean}
   * @default false
   */
  isApplicant: {
    type: Boolean,
    default: false,
  },
  /**
   * Specifies the default type of contact.
   * @type {Number}
   * @default -1 (no specific type)
   */
  defaultType: {
    type: Number,
    default: -1,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",

  /**
   * Emitted when a new contact is successfully created.
   * Notifies the parent component and provides the new contact ID.
   * @property {number} contactId - The unique identifier of the newly created contact.
   * @property {boolean} addProperty - Indicates if a property should be added after closing.
   */
  "contactCreated",

  /**
   * Emitted when the user selects a contact to edit.
   * Notifies the parent component to open the edit contact modal.
   * @property {number} contactId - The unique identifier of the selected contact.
   */
  "openEditContactModal",

  /**
   * Emitted when a new contact is created and the GDPR email needs to be sent.
   * Notifies the parent component to trigger the email process.
   * @property {number} contactId - The unique identifier of the newly created contact.
   */
  "emailNewContact",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const { getSystemContactTypeByTypeId } = useContactHelper();
const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const defaultContactData = ref<Contacts>();
const newContactData = ref<Contacts>();
const saving = ref(false);
const locked = ref(false);
const toggledField = ref("");
const showMarketingPrompt = ref(false);
const marketingPromptShown = ref(false);
const selectedTabPanel = ref(0);
const contactTypeStore = useContactTypeConfigurationStore();
const contactType = ref<ContactType>();
const openDuplicateContactModal = ref(false);
const duplicateRecords = ref<DuplicateContact[]>([]);
const duplicateModalTitleField = ref("");
const displayEmailForm = ref(false);
const newContactId = ref(-1);

const fetchContactType = async () => {
  if (!newContactData.value) {
    return;
  }

  contactType.value = await contactTypeStore.getContactType(
    newContactData.value.typeID,
  );
};

/** Checks if the conatct data has been updated since loading */
const contactDataChanged = computed(() =>
  newContactData.value && defaultContactData.value
    ? JSON.stringify(newContactData.value) !=
      JSON.stringify(defaultContactData.value)
    : false,
);

const propertyRequirementsDataChanged = computed(
  () =>
    maxPrice.value != originalMaxPrice ||
    minBedrooms.value != originalMinBedrooms ||
    propertyUsage.value != originalPropertyUsage ||
    propertyCategory.value != originalPropertyCategory,
);

const emptyApiModel: NewContactModel = {
  firstNames: "",
  lastName: "",
  titleId: 0,
  salutation: "",
  email: "",
  mobile: "",
  homeTelephone: "",
  homeAddress: {
    countryCode: CountryCode.UK,
    postCode: "",
    propertyName: "",
    street: "",
    locality: "",
    town: "",
    region: "",
    country: "",
  },
  companyName: "",
  businessTelephone: "",
  businessAddress: {
    countryCode: CountryCode.UK,
    postCode: "",
    propertyName: "",
    street: "",
    locality: "",
    town: "",
    region: "",
    country: "",
  },
  mailingAddress: 0,
  dateOfBirth: "",
  typeId: 0,
  requirements: {
    category: 0,
    usage: 5,
    maxPrice: 99999999,
    minBedrooms: 0,
  },
  marketingPreferences: {
    post: false,
    email: false,
    smsText: false,
    telephone: false,
    passDetailsToThirdParties: false,
    passDetailsToIFA: false,
    passDetailsToConveyancer: false,
  },
  assignedUserId: -1,
  siteId: -1,
};

const apiData = ref<NewContactModel>();
const resetValidState = ref(false);
const originalPropertyUsage = PropertyUsages.Residential;
const originalPropertyCategory = PropertyCategories.Buy;

const maxPrice = ref(99999999);
const minBedrooms = ref(0);
const propertyUsage = ref(PropertyUsages.Residential);
const propertyCategory = ref(PropertyCategories.Buy);

const validation = ref<EditAddressValidation>({
  propertyName: ContactsValidation.HomeProperty,
  street: ContactsValidation.HomeStreet,
  locality: ContactsValidation.HomeLocality,
  town: ContactsValidation.HomeTown,
  region: ContactsValidation.HomeRegion,
  postcode: ContactsValidation.HomePostcode,
});
const address = ref<Address>({
  countryCode: CountryCode.UK,
  postCode: "",
  propertyName: "",
  street: "",
  locality: "",
  town: "",
  region: "",
  country: "",
});

watch(
  () => props.lockInputs,
  () => {
    locked.value = props.lockInputs;
  },
);

const mapModel = () => {
  if (!apiData.value || !newContactData.value) {
    return;
  }

  // If a user has entered a company name, the business telphone model value needs to be set to
  // the entered telephone number
  if (newContactData.value.businessCompany) {
    apiData.value.businessTelephone = homeBusinessTelephoneNumber.value;
    apiData.value.businessAddress.propertyName = address.value.propertyName;
    apiData.value.businessAddress.street = address.value.street;
    apiData.value.businessAddress.locality = address.value.locality;
    apiData.value.businessAddress.town = address.value.town;
    apiData.value.businessAddress.region = address.value.region;
    apiData.value.businessAddress.postCode = address.value.postCode;
    apiData.value.businessAddress.countryCode = address.value.countryCode;
  } else {
    apiData.value.homeTelephone = homeBusinessTelephoneNumber.value;
    apiData.value.homeAddress.propertyName = address.value.propertyName;
    apiData.value.homeAddress.street = address.value.street;
    apiData.value.homeAddress.locality = address.value.locality;
    apiData.value.homeAddress.town = address.value.town;
    apiData.value.homeAddress.region = address.value.region;
    apiData.value.homeAddress.postCode = address.value.postCode;
    apiData.value.homeAddress.countryCode = address.value.countryCode;
  }

  ((apiData.value.companyName = newContactData.value.businessCompany),
    (apiData.value.firstNames = newContactData.value.firstNames),
    (apiData.value.lastName = newContactData.value.lastName),
    (apiData.value.titleId = newContactData.value.titleID),
    (apiData.value.salutation = newContactData.value.salutation),
    (apiData.value.email = newContactData.value.email),
    (apiData.value.mobile = newContactData.value.mobileTelephone),
    (apiData.value.mailingAddress = newContactData.value.mailingAddress),
    (apiData.value.dateOfBirth = newContactData.value.birthDate),
    (apiData.value.typeId = newContactData.value.typeID));
  apiData.value.requirements.category = propertyCategory.value;
  apiData.value.requirements.usage = propertyUsage.value;
  apiData.value.requirements.maxPrice = maxPrice.value;
  apiData.value.requirements.minBedrooms = minBedrooms.value;
  apiData.value.marketingPreferences.email =
    newContactData.value.emailingList == 1;
  apiData.value.marketingPreferences.smsText =
    newContactData.value.smsList == 1;
  apiData.value.marketingPreferences.telephone =
    newContactData.value.telephoneList == 1;
  apiData.value.marketingPreferences.passDetailsToThirdParties =
    newContactData.value.passDataTo3rdParties == 1;
  apiData.value.marketingPreferences.passDetailsToIFA =
    newContactData.value.passDataToIFA == 1;
  apiData.value.marketingPreferences.passDetailsToConveyancer =
    newContactData.value.passDataToConveyancer == 1;
  apiData.value.marketingPreferences.post =
    newContactData.value.mailingList == 1;
  apiData.value.assignedUserId = newContactData.value.assignedUserID;
  apiData.value.siteId = newContactData.value.siteID;
};

const createContact = async (e: any) => {
  const validate = e.validationGroup.validate();

  if (
    (!e.validationGroup._validationInfo.result.isValid && !validate.isValid) ||
    !apiData.value
  ) {
    return;
  }

  mapModel();
  let response: Id = { id: -1 };

  if (apiData.value.dateOfBirth == "") {
    apiData.value.dateOfBirth = moment("01/01/1900").format("DD/MM/YYYY");
  }

  try {
    saving.value = true;
    locked.value = true;
    response = await acquaintApiClient.httpPost(`app/contacts`, apiData.value);
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  } finally {
    saving.value = false;
    locked.value = false;
  }

  if (response.id == -1) {
    return;
  }

  let addPropertyAfterClose = false;

  if (await isAddPropertyPromptRequired()) {
    addPropertyAfterClose = await displayAddPropertyPrompt();
  }

  if (apiData.value.email != "") {
    const gdprAlert = await displayQuestionAlert(
      "For General Data Protection Regulations (GDPR) would you like to send this Contact the Marketing Preferences Email which will allow them to update their preferences?",
    );

    if (gdprAlert.isConfirmed) {
      emit("emailNewContact", response.id);
      newContactId.value = response.id;
      displayEmailForm.value = true;
    }
  }

  showCloseConfirmationPrompt.value = false;
  showModal.value = false;
  emit(
    "contactCreated",
    response.id,
    addPropertyAfterClose,
    `${apiData.value.firstNames} ${apiData.value.lastName}`,
  );
};

const isAddPropertyPromptRequired = async () => {
  if (!props.showAddPropertyPrompt || !contactType.value) {
    return false;
  }

  return (
    contactType.value.typeID == SystemContactTypes.Landlord ||
    contactType.value.typeID == SystemContactTypes.Vendor
  );
};

const displayAddPropertyPrompt = async () => {
  const result = await displayQuestionAlert(
    "Would you like to add this Contact's property now?",
  );
  return result.isConfirmed;
};

const showCloseConfirmationPrompt = ref(false);

const closeModal = () => {
  showModal.value = false;
};

const fetchDefaultData = async () => {
  try {
    defaultContactData.value = await acquaintApiClient.httpGet(
      `database/contacts/defaultmodel`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const cancelPromptAccepted = () => {
  showCloseConfirmationPrompt.value = false;
};

const cancelPromptDenied = () => {
  showCloseConfirmationPrompt.value = true;
};

// If we show the cancel confirmation modal and users wish to keep the modal open and not lose their changes, we do not wishe to reset the data.
watch(
  () => propertyRequirementsDataChanged.value,
  () => {
    showCloseConfirmationPrompt.value = propertyRequirementsDataChanged.value;
  },
);

watch(
  () => contactDataChanged.value,
  () => {
    showCloseConfirmationPrompt.value = contactDataChanged.value;
  },
);

watch(
  () => showModal.value,
  async () => {
    // If we show the cancel confirmation modal and users wish to keep the modal open and not lose their changes, we do not wishe to reset the data.
    // This prevents the reset of the inputs when the cancel confirmation modal appears.
    if (showCloseConfirmationPrompt.value || !showModal.value) {
      return;
    }

    // We need to excute this code and pass this ref down to the textboxes for the three name fields as otherwise, if a user enters just a first anme into
    // the first field and no data into the other 2 name fields, error icons will appear in these remaining fields if the modal is openend again.
    resetValidState.value = true;
    setTimeout(() => {
      resetValidState.value = false;
    }, 500);

    marketingPromptShown.value = false;

    // This takes users back to the main details tab when they open the modal after closing it.
    selectedTabPanel.value = 0;

    // The modal's inputs should be cleared when its closed.
    // To reset the contact data's, we must use parse and stringify to make vue's reactivity work,
    // otherwise, newContactData won't be reset

    if (!defaultContactData.value) {
      await fetchDefaultData();
    }

    newContactData.value = JSON.parse(JSON.stringify(defaultContactData.value));

    await fetchContactType();

    address.value = {
      countryCode: defaultContactData.value?.homeCountryCode ?? 0,
      postCode: "",
      propertyName: "",
      street: "",
      locality: "",
      town: "",
      region: "",
      country: "",
    };

    apiData.value = JSON.parse(JSON.stringify(emptyApiModel));

    maxPrice.value = 99999999;
    minBedrooms.value = 0;
    propertyUsage.value = PropertyUsages.Residential;
    homeBusinessTelephoneNumber.value = "";

    if (props.isOwner && newContactData.value) {
      newContactData.value.typeID = ContactTypeId.Vendor;
    }

    setDefaultCategoryBasedOnContactType();
    await setDefaultContactType();
  },
);

// Salutation must include the first name
watch(
  () => newContactData.value?.firstNames,
  () => {
    if (newContactData.value) {
      newContactData.value.salutation = newContactData.value?.firstNames;
    }
  },
);

const onToggled = (e: number, fieldName: string) => {
  // Store toggled field so we know which field to reset if user clicks no to prompt
  toggledField.value = fieldName;

  // We should only show the marketing modal if a user has agreed to certain peice of marketing.
  if (e && !marketingPromptShown.value) {
    showMarketingPrompt.value = true;
  }
};

const noConsent = async () => {
  if (!newContactData.value) {
    return;
  }

  // Only reset the toggled field instead of all fields when user clicks no to the verbal consent prompt
  switch (toggledField.value) {
    case "passDataToConveyancer":
      newContactData.value.passDataToConveyancer = 0;
      break;
    case "mailingList":
      newContactData.value.mailingList = 0;
      break;
    case "emailingList":
      newContactData.value.emailingList = 0;
      break;
    case "smsList":
      newContactData.value.smsList = 0;
      break;
    case "telephoneList":
      newContactData.value.telephoneList = 0;
      break;
    case "passDataTo3rdParties":
      newContactData.value.passDataTo3rdParties = 0;
      break;
    case "passDataToIFA":
      newContactData.value.passDataToIFA = 0;
      break;
  }

  marketingPromptShown.value = false;
  toggledField.value = "";
};

const enableMarketing = () => {
  marketingPromptShown.value = true;
};

const marketingConsentMessage = findQuestionText(211);

const selectChange = (e: any) => {
  switch (e.addedItems[0].title) {
    case ContactModalPages.MainDetails:
      selectedTabPanel.value = 0;
      break;
    case ContactModalPages.PropertyRequirements:
      selectedTabPanel.value = 1;
      break;
    case ContactModalPages.Address:
      selectedTabPanel.value = 2;
      break;
    case ContactModalPages.Marketing:
      selectedTabPanel.value = 3;
      break;
    case ContactModalPages.SystemInfo:
      selectedTabPanel.value = 4;
      break;
  }
};

const homeBusinessTelephoneNumber = ref("");

const disablePropertyRequirementsTab = computed(
  () =>
    contactType.value?.typeID == SystemContactTypes.Applicant ||
    contactType.value?.typeID == SystemContactTypes.Landlord ||
    contactType.value?.typeID == SystemContactTypes.Vendor ||
    contactType.value?.typeID == SystemContactTypes.EstateAgent,
);

watch(
  () => newContactData.value?.typeID,
  async () => {
    await fetchContactType();
    setDefaultCategoryBasedOnContactType();
  },
);

const setDefaultCategoryBasedOnContactType = () => {
  switch (contactType.value?.propertyCategory) {
    case 1:
      propertyCategory.value = PropertyCategories.Buy;
      break;
    case 2:
      propertyCategory.value = PropertyCategories.Rent;
      break;
    default:
      propertyCategory.value = PropertyCategories.Buy;
      break;
  }
};

const setDefaultContactType = async () => {
  if (props.defaultType > -1 && newContactData.value) {
    switch (props.defaultType) {
      case DefaultContactType.Tenant:
        newContactData.value.typeID = DefaultContactType.Tenant;
        break;
      case DefaultContactType.Guarantor:
        {
          const typeId = await getSystemContactTypeByTypeId(
            SystemContactTypes.Guarantor,
          );
          newContactData.value.typeID = typeId;
        }
        break;
      case DefaultContactType.PermittedOccupier:
        newContactData.value.typeID = DefaultContactType.PermittedOccupier;
        break;
      default:
        break;
    }
  }
};

const nameFieldRequired = computed(() => {
  return (
    !newContactData.value?.lastName && !newContactData.value?.businessCompany
  );
});
const secondNameFieldRequired = computed(() => {
  return (
    !newContactData.value?.firstNames && !newContactData.value?.businessCompany
  );
});
const companyNameFieldRequired = computed(() => {
  return !newContactData.value?.firstNames && !newContactData.value?.lastName;
});

// Salutation must include the first name
watch(
  () => newContactData.value?.firstNames,
  async (newValue) => {
    if (newContactData.value) {
      newContactData.value.salutation = newContactData.value?.firstNames;
    }

    if (!newContactData.value || !newValue || !newContactData.value.lastName) {
      return;
    }
    await nameFieldsCheckForDuplicate();
  },
);

watch(
  () => newContactData.value?.lastName,
  async (newValue) => {
    if (
      !newContactData.value ||
      !newValue ||
      !newContactData.value.firstNames
    ) {
      return;
    }

    await nameFieldsCheckForDuplicate();
  },
);

const nameFieldsCheckForDuplicate = async () => {
  duplicateRecords.value = [];

  try {
    duplicateRecords.value = await acquaintApiClient.httpPost<
      DuplicateContact[]
    >("app/contacts/duplicatechecks/namecheck", {
      firstName: newContactData.value?.firstNames,
      lastName: newContactData.value?.lastName,
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }

  if (duplicateRecords.value?.length > 0) {
    duplicateModalTitleField.value = "name";
    openDuplicateContactModal.value = true;
  }
};

watch(
  () => newContactData.value?.businessCompany,
  async (newValue) => {
    if (
      !newContactData.value ||
      !newValue ||
      (newContactData.value.lastName && newContactData.value.firstNames)
    ) {
      return;
    }

    await companyNameFieldsCheckForDuplicate();
  },
);

const companyNameFieldsCheckForDuplicate = async () => {
  duplicateRecords.value = [];

  try {
    duplicateRecords.value = await acquaintApiClient.httpPost<
      DuplicateContact[]
    >("app/contacts/duplicatechecks/companycheck", {
      companyName: newContactData.value?.businessCompany,
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }

  if (duplicateRecords.value?.length > 0) {
    duplicateModalTitleField.value = "company name";
    openDuplicateContactModal.value = true;
  }
};

watch(
  () => newContactData.value?.email,
  async (newValue) => {
    if (!newValue) {
      return;
    }

    await emailFieldsCheckForDuplicate();
  },
);

const emailFieldsCheckForDuplicate = async () => {
  duplicateRecords.value = [];

  try {
    duplicateRecords.value = await acquaintApiClient.httpPost<
      DuplicateContact[]
    >("app/contacts/duplicatechecks/emailcheck", {
      email: newContactData.value?.email,
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }

  if (duplicateRecords.value?.length > 0) {
    duplicateModalTitleField.value = "email";
    openDuplicateContactModal.value = true;
  }
};

watch(
  () => newContactData.value?.mobileTelephone,
  async (newValue) => {
    if (newValue == "") {
      return;
    }

    await mobileNumberFieldCheckForDuplicate();
  },
);

const mobileNumberFieldCheckForDuplicate = async () => {
  duplicateRecords.value = [];

  try {
    duplicateRecords.value = await acquaintApiClient.httpPost<
      DuplicateContact[]
    >("app/contacts/duplicatechecks/mobilecheck", {
      mobile: newContactData.value?.mobileTelephone,
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }

  if (duplicateRecords.value?.length > 0) {
    duplicateModalTitleField.value = "mobile";
    openDuplicateContactModal.value = true;
  }
};

// If a user has started to create a new contact, chosen to edit an already existing record, the edit modal must be opened with this selected
// contact's details.
const selectContact = (id: number) => {
  showCloseConfirmationPrompt.value = false;
  showModal.value = false;
  emit("openEditContactModal", id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(modalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showModal).value = $event)),
      title: "Contact",
      width: _unref(ModalWidth).Small,
      showCloseButton: !saving.value,
      height: "65vh",
      saving: saving.value,
      showCloseConfirmationPrompt: showCloseConfirmationPrompt.value,
      "help-page": "adding-a-contact",
      onCancelPromptAccepted: cancelPromptAccepted,
      onCancelPromptDenied: cancelPromptDenied
    }, {
      content: _withCtx(() => [
        (newContactData.value)
          ? (_openBlock(), _createBlock(_unref(DxTabPanel), {
              key: 0,
              "scroll-by-content": true,
              "show-nav-buttons": true,
              "swipe-enabled": false,
              width: "100%",
              selectedIndex: selectedTabPanel.value,
              onSelectionChanged: selectChange
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxItem), { title: "Main Details" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _hoisted_2,
                      _createElementVNode("section", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createVNode(AcquaintTextbox, {
                            modelValue: newContactData.value.firstNames,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newContactData.value.firstNames) = $event)),
                            label: "First Name",
                            fieldValidation: _unref(ContactsValidation).FirstNames,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            resetValid: resetValidState.value,
                            "required-input": nameFieldRequired.value,
                            "value-change-event": _unref(TextboxValueChangeEvent).Change,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly", "resetValid", "required-input", "value-change-event"]),
                          _createVNode(AcquaintTextbox, {
                            modelValue: newContactData.value.lastName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newContactData.value.lastName) = $event)),
                            label: "Last Name",
                            fieldValidation: _unref(ContactsValidation).LastName,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            "required-input": secondNameFieldRequired.value,
                            resetValid: resetValidState.value,
                            "value-change-event": _unref(TextboxValueChangeEvent).Change,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly", "required-input", "resetValid", "value-change-event"]),
                          _createVNode(lookupSingleSelect, {
                            modelValue: newContactData.value.titleID,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newContactData.value.titleID) = $event)),
                            "lookup-source": _unref(LookupTableSource).Titles,
                            label: "Title",
                            readOnly: locked.value,
                            width: _unref(FieldSize).Large,
                            requiredInput: true,
                            showSearch: false,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "lookup-source", "readOnly", "width"]),
                          _createVNode(AcquaintTextbox, {
                            modelValue: newContactData.value.salutation,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newContactData.value.salutation) = $event)),
                            label: "Salutation",
                            fieldValidation: _unref(ContactsValidation).Salutation,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(AcquaintTextbox, {
                            modelValue: newContactData.value.businessCompany,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newContactData.value.businessCompany) = $event)),
                            label: "Company Name",
                            fieldValidation: _unref(ContactsValidation).BusinessCompany,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            resetValid: resetValidState.value,
                            "required-input": companyNameFieldRequired.value,
                            "value-change-event": _unref(TextboxValueChangeEvent).Change,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly", "resetValid", "required-input", "value-change-event"]),
                          _createVNode(AcquaintTextbox, {
                            modelValue: newContactData.value.email,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newContactData.value.email) = $event)),
                            label: "Email",
                            fieldValidation: _unref(ContactsValidation).Email,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            requiredInput: false,
                            "value-change-event": _unref(TextboxValueChangeEvent).Change,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly", "value-change-event"]),
                          _createVNode(AcquaintTextbox, {
                            modelValue: newContactData.value.mobileTelephone,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newContactData.value.mobileTelephone) = $event)),
                            label: "Mobile Telephone",
                            fieldValidation: _unref(ContactsValidation).HomeTelephone,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            "value-change-event": _unref(TextboxValueChangeEvent).Change,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly", "value-change-event"]),
                          _createVNode(AcquaintTextbox, {
                            modelValue: homeBusinessTelephoneNumber.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((homeBusinessTelephoneNumber).value = $event)),
                            label: " Telephone",
                            fieldValidation: _unref(ContactsValidation).BusinessTelephone,
                            width: _unref(FieldSize).Large,
                            readOnly: locked.value,
                            "value-change-event": _unref(TextboxValueChangeEvent).Change,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly", "value-change-event"]),
                          _createVNode(NewContactTypeLookup, {
                            label: "Type",
                            modelValue: newContactData.value.typeID,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newContactData.value.typeID) = $event)),
                            readOnly: locked.value || props.isApplicant,
                            width: _unref(FieldSize).Large,
                            "validation-group": "contact-modal"
                          }, null, 8, ["modelValue", "readOnly", "width"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), {
                  title: "Property Requirements",
                  disabled: !disablePropertyRequirementsTab.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _createVNode(SystemCodeSingleSelect, {
                            label: "Category",
                            "code-type": _unref(CodeType).ContactCategory,
                            modelValue: propertyCategory.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((propertyCategory).value = $event))
                          }, null, 8, ["code-type", "modelValue"]),
                          _createVNode(BedroomsSelect, {
                            modelValue: minBedrooms.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((minBedrooms).value = $event)),
                            label: "Min Bedrooms",
                            readOnly: locked.value
                          }, null, 8, ["modelValue", "readOnly"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(SystemCodeSingleSelect, {
                            label: "Usage",
                            modelValue: propertyUsage.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((propertyUsage).value = $event)),
                            "code-type": _unref(CodeType).PropertyUsage
                          }, null, 8, ["modelValue", "code-type"]),
                          _createVNode(CurrencyInput, {
                            modelValue: maxPrice.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((maxPrice).value = $event)),
                            label: "Max Price",
                            minValue: 0,
                            maxValue: 99999999,
                            readOnly: locked.value
                          }, null, 8, ["modelValue", "readOnly"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(DxItem), { title: "Address" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(EditAddress, {
                        modelValue: address.value,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((address).value = $event)),
                        validation: validation.value,
                        "read-only": props.lockInputs,
                        width: _unref(FieldSize).Large,
                        "validation-group": "contact-modal"
                      }, null, 8, ["modelValue", "validation", "read-only", "width"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: "Marketing Preferences" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(MarketingPreferenceToggles, {
                        modelValue: newContactData.value,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newContactData).value = $event)),
                        readOnly: locked.value,
                        onOnValueChange: onToggled
                      }, null, 8, ["modelValue", "readOnly"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: "System Info" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(LookupSingleSelect, {
                        modelValue: newContactData.value.assignedUserID,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((newContactData.value.assignedUserID) = $event)),
                        label: "Assigned User",
                        lookupSource: _unref(LookupTableSource).Users,
                        width: _unref(FieldSize).Medium
                      }, null, 8, ["modelValue", "lookupSource", "width"]),
                      _createVNode(LookupSingleSelect, {
                        modelValue: newContactData.value.siteID,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newContactData.value.siteID) = $event)),
                        label: "Site/Branch",
                        lookupSource: _unref(LookupTableSource).Sites,
                        width: _unref(FieldSize).Medium,
                        allowZeroValue: true,
                        "validation-group": "contact-modal"
                      }, null, 8, ["modelValue", "lookupSource", "width"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["selectedIndex"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Save',
          onClick: (e) => {
            createContact(e);
          },
          disabled: saving.value,
          validationGroup: 'contact-modal',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            closeModal();
          },
          disabled: saving.value,
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "showCloseButton", "saving", "showCloseConfirmationPrompt"]),
    _createVNode(DuplicateContactModal, {
      modelValue: openDuplicateContactModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((openDuplicateContactModal).value = $event)),
      contacts: duplicateRecords.value,
      onSelectContact: selectContact,
      titleField: duplicateModalTitleField.value
    }, null, 8, ["modelValue", "contacts", "titleField"]),
    _createVNode(QuestionModal, {
      modelValue: showMarketingPrompt.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((showMarketingPrompt).value = $event)),
      title: "Marketing Preferences",
      confirmButtonText: "Yes",
      rejectButtonText: "No",
      onConfirm: enableMarketing,
      onReject: noConsent,
      messageText: _unref(marketingConsentMessage)
    }, null, 8, ["modelValue", "messageText"]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailForm.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((displayEmailForm).value = $event)),
      contactList: [newContactId.value],
      emailTemplateId: _unref(EmailTemplates).gdprMailingList
    }, null, 8, ["modelValue", "contactList", "emailTemplateId"])
  ], 64))
}
}

})